// extracted by mini-css-extract-plugin
export var buttonContent = "_4b-0";
export var centered = "_4b-1";
export var centeredFlex = "_4b-2";
export var errorText = "_4b-3";
export var icon = "_4b-4";
export var iconButtonContent = "_4b-5";
export var monospace = "_4b-6";
export var padded = "_4b-7";